import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=9b691604"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b691604')) {
      api.createRecord('9b691604', component.options)
    } else {
      api.reload('9b691604', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=9b691604", function () {
      api.rerender('9b691604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/site/settings.vue"
export default component.exports